import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { ROOT_PATH } from '@shared/constants/paths';
import useIsAuthenticated from '@shared/hooks/useIsAuthenticated';

import { HomePageContent } from '../components';

const LoginPage = () => {
  const { isAuthenticated } = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROOT_PATH, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <HomePageContent />;
};

export default LoginPage;
